import { Input } from 'antd'
import { AdminsEcommerceGetProductCategoryItem } from 'generated/api'
import CategoriesTable from './CategoriesTable'
import Card from 'components/card/Card'
import { IconSearch } from 'components/icons'
import Errors from 'components/errors/Errors'
import Pagination from 'components/pagination/Pagination'
import ButtonLink from 'components/button/Button'

interface CategoriesIndexProps {
  fetchStatus: 'loading' | 'idle' | 'failed'
  categories: AdminsEcommerceGetProductCategoryItem[]
  page: number
  limit: number
  totalRows: number
  keywordSearch: string
  onChangePage: (page: number) => void
  onChangeLimit: (limit: number) => void
  onChangeKeyword: (keyword: string) => void
  onSearch: () => void
  onFetch: () => void
  onOpenModal: (category?: AdminsEcommerceGetProductCategoryItem) => void
}

export default function CategoriesIndex(props: CategoriesIndexProps) {
  const {
    fetchStatus,
    categories,
    page,
    limit,
    totalRows,
    keywordSearch,
    onChangePage,
    onChangeLimit,
    onChangeKeyword,
    onSearch,
    onFetch,
    onOpenModal,
  } = props

  const loading = fetchStatus === 'loading'
  const failed = fetchStatus === 'failed'
  const idle = fetchStatus === 'idle'

  return (
    <Card
      loading={loading}
      dataTestId="card-categories-index"
      spinnerTestId="loader_orders"
      className="rounded-xl p-0"
    >
      {failed ? (
        <Errors
          dataTestId="categories"
          inverse={false}
          button={true}
          header="Mohon maaf, permintaan Anda tidak dapat diproses."
          paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
          buttonLabel="Coba lagi"
          buttonAction={onFetch}
        />
      ) : null}

      {idle || loading ? (
        <div data-testid="container-categories">
          <Card.Header className="sticky-card-header block xl:flex xl:justify-between py-2 px-4">
            <div className="xl:w-1/5 mb-4 xl:mb-0">
              <Input
                prefix={<IconSearch />}
                className="input-search"
                data-testid="input-search-categories"
                placeholder="Cari nama kategori..."
                style={{ height: 40 }}
                disabled={loading}
                value={keywordSearch}
                onChange={e => onChangeKeyword(e.target.value)}
                onPressEnter={onSearch}
              />
            </div>
            <div className="xl:w-4/5 mb-4 xl:mb-0">
              <div className="xl:flex xl:flex-row-reverse xl:gap-4 h-full">
                <div className="xl:w-1/5 mb-4 xl:mb-0 h-full">
                  <ButtonLink
                    data-testid="button-add-category"
                    variant="solid-primary"
                    block={true}
                    label="Tambah Kategori"
                    className="text-sm h-full"
                    onClick={() => onOpenModal()}
                  />
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="mt-0">
            <CategoriesTable data={categories} loading={loading} onClickDetail={onOpenModal} />
          </Card.Body>
          <Card.Footer>
            <div className="px-4 py-3">
              <Pagination
                setLimit={(limit: number) => onChangeLimit(limit)}
                onPageChanged={(page: number) => onChangePage(page)}
                totalRows={totalRows}
                currentPage={page}
                limit={limit}
                showLimitPage={true}
              />
            </div>
          </Card.Footer>
        </div>
      ) : null}
    </Card>
  )
}
